var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-container pa-w-full pa-h-full pa-overflow-hidden pa-flex pa-flex-col pa-min-w-[1280px]"},[_c('div',{staticClass:"lab-view-root pa-h-full pa-w-full pa-flex"},[_c('div',{staticClass:"lab-wrapper pa-flex-1 pa-overflow-hidden"},[_c('RouterView')],1),_vm._v(" "),_c(_setup.History)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }